import script from "./MyVeBalCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyVeBalCards.vue?vue&type=script&setup=true&lang=ts"

import "./MyVeBalCards.vue?vue&type=style&index=0&id=6c351ae9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c351ae9"]])

export default __exports__